export default __webpack_public_path__ + "static/media/semaiPro_h_white_bg_trans.c5f96479.png";